/**
 * Auth state machine.
 *
 *   tokenAtom               — текущий токен (general после login, scoped
 *                             после выбора permission'а). null = не залогинен.
 *   userAtom                — данные юзера, приходят с login response.
 *   selectedPermissionAtom  — выбранный permission. До picker'а null;
 *                             ставится одновременно с обменом на scoped токен.
 *   isAuthenticatedAtom     — derived: token + permission оба есть. Только
 *                             такая комбинация = полноценная сессия.
 *   logoutAtom              — write-only action: сбрасывает всё.
 *
 * Persist: всё через `atomWithStorage`. Ключ токена общий с `http.ts`
 * (`TOKEN_STORAGE_KEY`), поэтому axios-слой и атомы синхронизированы.
 */

import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

import type {Permission, User} from '@services/auth';
import {PERMISSION_STORAGE_KEY, TOKEN_STORAGE_KEY, USER_STORAGE_KEY} from '@services/utils';

export const tokenAtom = atomWithStorage<string | null>(TOKEN_STORAGE_KEY, null, undefined, {
  getOnInit: true,
});
export const userAtom = atomWithStorage<User | null>(USER_STORAGE_KEY, null, undefined, {
  getOnInit: true,
});
export const selectedPermissionAtom = atomWithStorage<Permission | null>(
  PERMISSION_STORAGE_KEY,
  null,
  undefined,
  {getOnInit: true},
);

export const isAuthenticatedAtom = atom(
  (get) => get(tokenAtom) !== null && get(selectedPermissionAtom) !== null,
);

export const logoutAtom = atom(null, (_get, set) => {
  set(tokenAtom, null);
  set(userAtom, null);
  set(selectedPermissionAtom, null);
});
